/* eslint import/prefer-default-export: off */

import { useState, useRef, useEffect } from 'react';

export function useOutside(isDisplay, event) {
	const inside = useRef(null);

	useEffect(() => {
		const listener = (evt) => {
			if (
				inside.current
		&& evt.target
		&& !inside.current.contains(evt.target)
			) {
				isDisplay && event(evt);
			}
		};


		document.addEventListener('click', listener, true);

		return () => {
			document.removeEventListener('click', listener, true);
		};
	}, [event, inside]);

	return inside;
}

export function useDebounce(value, delay = 500) {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		// Cancel the timeout if value changes (also on delay change or unmount)
		return () => {
			clearTimeout(handler);
		};
	}, [value, delay]);

	return debouncedValue;
}
